export class HttpError {
    static BadRequest = 400;
    static Unauthorized = 401;
    static Forbidden = 403;
    static NotFound = 404;
    static TimeOut = 408;
    static Conflict = 409;
    static Gone = 410;
    static UnavailableForLegalReasons = 451;
    static InternalServerError = 500;
}
